const getUserAccesses = (accessList) => {
  const accesses = {
    hasFullAccess: accessList[0].hasFullAccess
  }

  accessList.forEach(access => {
    access.endpoints.forEach(endpoint => {
      if (!endpoint.tag) return

      accesses[endpoint.tag] = endpoint.tag
    })
  })

  return accesses
}

export default getUserAccesses